type PreloadImageSourceFn = (source: string) => Promise<void>;

export const preloadImageSource: PreloadImageSourceFn = (source) =>
	new Promise((resolve, reject) => {
		const imageElement: HTMLImageElement = document.createElement('img');

		imageElement.src = source;

		imageElement.onload = () => resolve();
		imageElement.onerror = () => reject();
	});
